import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { SensordataComponent } from '../sensordata/sensordata.component';
import { SharedService } from '../../shared.service';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/first';

@Injectable()
export class LiveDataResolve implements Resolve<Object> {
  currentUser: string;
  constructor(private sensordataComponent: SensordataComponent, private pagedata: SharedService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
      return null;
    }
}
